import {Component, Input, OnInit} from '@angular/core';
import {GetStoreListInterface} from '@app/feature/store-admin/services/GetStoreList.interface';
import { StoreService } from '../../services/store.service';
import { ErrorhandlerService } from '../../../../shared/services/errorhandler/errorhandler.service';
import { TextDialogueComponent } from '../../../../auth/TextDialogue/TextDialogue.component';
import { ConfirmDialougeComponent } from '../../../../auth/confirm-dialouge/confirm-dialouge.component';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-store-list-item-sub-component',
  templateUrl: './store-list-item-sub-component.component.html',
  styleUrls: ['./store-list-item-sub-component.component.css']
})
export class StoreListItemSubComponentComponent implements OnInit {

  @Input() store: GetStoreListInterface;
    errorhandlerService: any;
   
  constructor(public storeService: StoreService, errorhandlerService: ErrorhandlerService, private dialog: MatDialog,) { }

  ngOnInit() {
  }

  openDialog(StoreId: any, StoreName:any) {
    var text = "Are you sure want to delete the " + StoreName +" store ?";      
    var uniqueId = StoreId;
    this.dialog.open(ConfirmDialougeComponent, {
      width: '400px',
      height: '300px',
      data: { Title: "Confirm Store Delete", Description: text, UniqueId: uniqueId,removeUser: false }
    });
  }
 
}
